import axios from "axios";
import type { InternalAxiosRequestConfig, AxiosError } from "axios";
import { API_BASE_URL } from "../utils/config";

const isNetworkAvailable = (): boolean => {
  return navigator.onLine;
};

const authInterceptor = (
  config: InternalAxiosRequestConfig,
): InternalAxiosRequestConfig => {
  const token = localStorage.getItem("authToken");
  const userJson = localStorage.getItem("user");
  if (token && userJson) {
    const user = JSON.parse(userJson);
    config.headers = config.headers || {};
    config.headers["Espo-Authorization"] = btoa(`${user.userName}:${token}`);
    delete (config.headers as Record<string, unknown>)["X-Api-Key"];
  }
  return config;
};

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: { "Content-Type": "application/json" },
});

apiClient.interceptors.request.use(authInterceptor);

apiClient.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    if (!isNetworkAvailable() && !error.response) {
      error.message = "Нет подключения к интернету";
    }

    if (error.response?.status === 401) {
      localStorage.clear();
      window.location.href = "/login";
    }
    return Promise.reject(error);
  },
);

const fileClient = axios.create({
  baseURL: API_BASE_URL,
});

fileClient.interceptors.request.use((config) => {
  const cfg = authInterceptor(config);
  if (cfg.data instanceof FormData) {
    cfg.headers = cfg.headers || {};
    cfg.headers["Content-Type"] = "multipart/form-data";
  }
  return cfg;
});

fileClient.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    if (!isNetworkAvailable() && !error.response) {
      error.message = "Нет подключения к интернету";
    }

    if (error.response?.status === 401) {
      localStorage.clear();
      window.location.href = "/login";
    }
    return Promise.reject(error);
  },
);

export default apiClient;
export { fileClient };
